import React from 'react';
import { Box, Heading, Stack, Body, BoxProps } from '@hover/blueprint';

export type HowItWorks = {
  title: string;
  body: string;
  icon: JSX.Element;
}[];

interface IHowItWorksProps extends BoxProps {
  items: HowItWorks;
}

const PartnerAppHowItWorks = ({ items, ...boxProps }: IHowItWorksProps) => (
  <Box {...boxProps} d="block" textAlign="center">
    <Heading size={{ base: 500, tablet: 600, desktop: 700 }} sx={{ mb: 24 }}>
      How It Works
    </Heading>
    <Stack direction="column" gap={16}>
      <Stack direction={{ base: 'column', tablet: 'row' }} gap={24}>
        {items.slice(0, 2).map(item => (
          <Stack
            key={item.title}
            direction="column"
            w="100%"
            alignItems="center"
            maxW="400px"
          >
            {item.icon}
            <Heading style={{ marginBottom: 0, marginTop: 24 }} size={500}>
              {item.title}
            </Heading>
            <Body>{item.body}</Body>
          </Stack>
        ))}
      </Stack>
      <Stack direction={{ base: 'column', tablet: 'row' }} gap={24}>
        {items.slice(2, 4).map(item => (
          <Stack
            key={item.title}
            direction="column"
            flex={1}
            alignItems="center"
            maxW="400px"
          >
            {item.icon}
            <Heading style={{ marginBottom: 0, marginTop: 24 }} size={500}>
              {item.title}
            </Heading>
            <Body>{item.body}</Body>
          </Stack>
        ))}
      </Stack>
    </Stack>
  </Box>
);

export default PartnerAppHowItWorks;
